(function () {
  const ROOT_SELECTOR = '.contact-form';
  const PHONE_CHARS = /^[\d\s+\-().]+$/;

  function messagesFor(el) {
    const root = el.closest(ROOT_SELECTOR);
    return {
      nameInvalid:
        (root && root.dataset.nameInvalid) ||
        'Enter a valid name using letters. Names made only of numbers or symbols are not allowed.',
      phoneInvalid:
        (root && root.dataset.phoneInvalid) || 'Enter a valid phone number with 7 to 15 digits.',
    };
  }

  function isValidName(value) {
    const name = String(value || '').trim();
    if (!name) return true;
    if (name.length < 2) return false;
    try {
      if (!/\p{L}/u.test(name)) return false;
      return /^[\p{L}\p{M}\s'\-\.]+$/u.test(name);
    } catch (error) {
      if (!/[A-Za-z\u00C0-\u024F]/.test(name)) return false;
      return /^[A-Za-z\u00C0-\u024F\s'\-\.]+$/.test(name);
    }
  }

  function isValidPhone(value, required) {
    const phone = String(value || '').trim();
    if (!phone) return !required;
    if (!PHONE_CHARS.test(phone) || /[a-zA-Z]/.test(phone)) return false;

    const digits = phone.replace(/\D/g, '');
    return digits.length >= 7 && digits.length <= 15;
  }

  function fieldKind(input) {
    if (!(input instanceof HTMLInputElement) || input.disabled || input.type === 'hidden') return null;
    if (!input.closest(ROOT_SELECTOR)) return null;

    const explicit = (input.getAttribute('data-validate') || '').toLowerCase();
    if (explicit === 'name' || explicit === 'phone') return explicit;
    if (input.type === 'tel') return 'phone';
    if ((input.getAttribute('autocomplete') || '').toLowerCase() === 'name') return 'name';
    return null;
  }

  function ensureErrorEl(input) {
    const field = input.closest('.form-field') || input.parentElement;
    let errorEl = field.querySelector('[data-js-field-error]');
    if (errorEl) return errorEl;

    errorEl = document.createElement('span');
    errorEl.className = 'form-message form-message--small form-message--error';
    errorEl.setAttribute('data-js-field-error', '');
    errorEl.hidden = true;
    input.insertAdjacentElement('afterend', errorEl);
    return errorEl;
  }

  function setFieldError(input, message) {
    const errorEl = ensureErrorEl(input);
    if (message) {
      input.setCustomValidity(message);
      input.setAttribute('aria-invalid', 'true');
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      input.setCustomValidity('');
      input.removeAttribute('aria-invalid');
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function validateField(input) {
    const kind = fieldKind(input);
    if (!kind) return true;

    const required = input.required || input.getAttribute('aria-required') === 'true';
    const value = input.value.trim();
    const messages = messagesFor(input);

    if (!value) {
      setFieldError(input, '');
      return !required;
    }

    let message = '';
    if (kind === 'name' && !isValidName(value)) {
      message = messages.nameInvalid;
    } else if (kind === 'phone' && !isValidPhone(value, required)) {
      message = messages.phoneInvalid;
    }

    setFieldError(input, message);
    return !message;
  }

  function validatedFields(form) {
    return Array.from(form.querySelectorAll('input')).filter((input) => fieldKind(input));
  }

  function onSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest(ROOT_SELECTOR)) return;

    const fields = validatedFields(form);
    if (!fields.length) return;

    let firstInvalid = null;
    fields.forEach((input) => {
      if (!validateField(input) && !firstInvalid) firstInvalid = input;
    });

    if (firstInvalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      firstInvalid.focus();
      firstInvalid.reportValidity();
    }
  }

  function onBlur(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !fieldKind(input)) return;
    validateField(input);
  }

  function onInput(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !fieldKind(input)) return;
    if (input.getAttribute('aria-invalid') === 'true' || input.validationMessage) {
      validateField(input);
    }
  }

  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('focusout', onBlur, true);
  document.addEventListener('input', onInput, true);

  window.ContactFormValidation = {
    isValidName: isValidName,
    isValidPhone: isValidPhone,
  };
})();
